<template style="height: 100%;">
  <div class="ExamineActivity">
    <el-tabs v-model="activeName" @tab-click="handleClick">

      <el-tab-pane label="待处理" name="first">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" style="margin-left: 1%;">
          <el-form-item label="活动主题">
            <el-input v-model="formInline.subject" placeholder="活动主题"></el-input>
          </el-form-item>
          <el-form-item label="活动类型">
            <el-select v-model="formInline.eventType" placeholder="活动区域">
              <el-option label="全部" value="0"></el-option>
              <el-option label="体验型" value="1"></el-option>
              <el-option label="治疗性" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="举办方式">
            <el-select v-model="formInline.holdType" placeholder="举办方式">
              <el-option label="全部" value="0"></el-option>
              <el-option label="组织活动" value="1"></el-option>
              <!-- <el-option label="自助活动" value="2"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="primary" @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="width: 100%;height: 12px;background-color: rgb(235, 236, 237);"></div>
        <el-table v-loading="loading" :data="tableData" style="width: 98%;margin-top: 14px;margin-left: 1%;">
          <el-table-column prop="eventKey" label="活动编号"></el-table-column>
          <el-table-column prop="subject" label="活动主题"></el-table-column>
          <el-table-column prop="eventType" label="活动类型">
            <template slot-scope="scope">
              <span v-if="scope.row.eventType == 1">体验型活动</span>
              <span v-if="scope.row.eventType == 2">治疗性活动</span>
            </template>
          </el-table-column>
          <el-table-column prop="eventRate" label="活动形式">
            <template slot-scope="scope">
              <span v-if="scope.row.eventRate == 1">单次</span>
              <span v-if="scope.row.eventRate == 2">连续</span>
            </template>
          </el-table-column>
          <el-table-column prop="chargePerson" label="负责人"></el-table-column>
          <el-table-column prop="eventStatus" label="审批状态">
            <template slot-scope="scope">
              <span v-if="scope.row.eventStatus == 1">立项</span>
              <span v-if="scope.row.eventStatus == 2">审核中</span>
              <span v-if="scope.row.eventStatus == 3">审核通过</span>
              <span v-if="scope.row.eventStatus == 4">驳回修改</span>
              <span v-if="scope.row.eventStatus == 5">拒绝</span>
              <span v-if="scope.row.eventStatus == 6">发布</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column prop="" label="操作">
            <template slot-scope="scope">
              <span class="w" @click="looks(scope.row,1)">查看</span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination 
        @current-change="handleCurrentChange" 
        :current-page.sync="formInline.pageIndex" 
        :page-size="10" 
        layout="total, prev, pager, next" 
        :total="Counts"></el-pagination>

      </el-tab-pane>

      <el-tab-pane label="往期记录" name="second">
        <el-form :inline="true" :model="formInline2" class="demo-form-inline" style="margin-left: 1%;">
          <el-form-item label="活动主题">
            <el-input v-model="formInline2.subject" placeholder="活动主题"></el-input>
          </el-form-item>
          <el-form-item label="活动类型">
            <el-select v-model="formInline2.eventType" placeholder="活动区域">
              <el-option label="全部" value="0"></el-option>
              <el-option label="体验型" value="1"></el-option>
              <el-option label="治疗性" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="举办方式">
            <el-select v-model="formInline2.holdType" placeholder="举办方式">
              <el-option label="全部" value="0"></el-option>
              <el-option label="组织活动" value="1"></el-option>
              <el-option label="自助活动" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit2">查询</el-button>
          </el-form-item>
        </el-form>
        

        <div style="width: 100%;height: 12px;background-color: rgb(235, 236, 237);"></div>
        <el-table v-loading="loading2" :data="tableData2" style="width: 98%;margin-top: 14px;margin-left: 1%;">
          <el-table-column prop="eventKey" label="活动编号"></el-table-column>
          <el-table-column prop="subject" label="活动主题"></el-table-column>
          <el-table-column prop="eventTypeStr" label="活动类型"></el-table-column>
          <el-table-column prop="eventRateStr" label="活动形式"></el-table-column>
          <el-table-column prop="chargePerson" label="负责人"></el-table-column>
          <el-table-column prop="eventStatus" label="审批状态">
            <template slot-scope="scope">
              <span v-if="scope.row.eventStatus == 1">立项</span>
              <span v-if="scope.row.eventStatus == 2">审核中</span>
              <span v-if="scope.row.eventStatus == 3">审核通过</span>
              <span v-if="scope.row.eventStatus == 4">驳回修改</span>
              <span v-if="scope.row.eventStatus == 5">拒绝</span>
              <span v-if="scope.row.eventStatus == 6">发布</span>
            </template>
          </el-table-column>

          <el-table-column prop="createTime" label="创建时间"></el-table-column>

          <el-table-column prop="" label="操作">
            <template slot-scope="scope">
              <span class="w" @click="looks(scope.row,2)">查看</span>
            </template>
          </el-table-column>
          
        </el-table>

        <el-pagination @current-change="handleCurrentChange2" 
        :current-page.sync="formInline2.pageIndex" 
        :page-size="10" 
        layout="total, prev, pager, next" :total="Counts2"></el-pagination>

      </el-tab-pane>
    </el-tabs>

    <el-dialog title="活动详情" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
      <p style="width: 80%;margin-left: 10%;">
        <span style="color: rgba(37, 37, 37, 0.5);  display: inline-block;width: 115px;text-align: right;">活动主题：</span>
        <span style="font-weight: 700;">{{ lookdata.subject }}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">活动类型：</span>
        <span style="font-weight: 700;">{{ lookdata.eventType == 1?'体验型活动':'治疗性活动' }}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">活动形式：</span>
        <span style="font-weight: 700;">{{ lookdata.eventRate == 1 ? '单次' : '连续' }}</span>
        <!-- <li><span>活动形式：</span>{{ looklist.eventRate == 1?'单次':'连续' }}</li> -->
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">报名时间：</span>
        <span style="font-weight: 700;">{{ lookdata.signStartTime }} - {{ lookdata.signEndTime }}</span>
      </p>

      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">举办时间：</span>
        <span style="font-weight: 700;">{{ lookdata.eventStartTime }}日 {{lookdata.eventStartTiming}} - {{ lookdata.eventEndTime }}日 {{lookdata.eventEndTiming}}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">活动地点：</span>
        <span style="font-weight: 700;">{{ lookdata.address }}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">活动对象：</span>
        <span style="font-weight: 700;">{{ lookdata.eventLimit ==1?"院内活动":'外院联合活动' }}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">活动人数：</span>
        <span style="font-weight: 700;">{{ lookdata.signNum }}</span>
      </p>

      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">参加活动院系：</span>
        <span style="font-weight: 700;" v-for="(item,i) in lookdata.tged" :key="i">{{ item.deptName }} </span>
      </p>

      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">活动内容：</span>
        <span style="font-weight: 700;">{{ lookdata.evenContent }}</span>
      </p>
      
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">活动预算：</span>
        <span style="font-weight: 700;">{{ lookdata.eventBudget }}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">是否需要预报名：</span>
        <span style="font-weight: 700;">{{ lookdata.preSignFlg == 1 ? '需要预报名' : '不需要预报名' }}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">限制报名人数：</span>
        <span style="font-weight: 700;">{{ lookdata.preSignNum }}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">预报名筛选表：</span>
        <span style="font-weight: 700;">{{ lookdata.prePaperCode }}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">是否招募志愿者：</span>
        <span style="font-weight: 700;">{{ lookdata.volunteerFlg == 1 ? '需要招募志愿者' : '不需要招募志愿者' }}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">志愿者人数：</span>
        <span style="font-weight: 700;">{{ lookdata.receiveNum }}</span>
      </p>
      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">相关附件名称：</span>
        <span style="font-weight: 700;" v-for="(item,i) in lookdata.tgea" :key="i">{{ item.path }}</span>
        <a v-for="(item,i) in lookdata.tgea" :key="i" :href="item.path" style="margin-left:20px;color: #409EFF;">查看</a>

      </p>


      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">立项人：</span>
        <span style="font-weight: 700;">{{ lookdata.creatorName }}</span>
      </p>


      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">活动负责人：</span>
        <span style="font-weight: 700;">{{ lookdata.chargePerson }}</span>
      </p>

      <p style="width: 80%;margin-left: 10%;margin-top: 20px;">
        <span style="color: rgba(37, 37, 37, 0.5); display: inline-block;width: 115px;text-align: right;">活动负责人电话：</span>
        <span style="font-weight: 700;">{{ lookdata.chargePersonPhone }}</span>
      </p>

      <div style="border-top: 2px solid rgb(231, 231, 231);margin-top: 30px;"></div>
      <h2 style="font-size: 16px;margin-top: 20px;">审批流程</h2>
      <!-- lookdata.associationPresident判断是不是心里协会会长 -->
      <div v-if="!lookdata.associationPresident">

        <div style="width: 80%;height: 60px;border-bottom: 1px solid rgb(209, 209, 209);margin-left: 10%;margin-top: 20px;position: relative;">
          <span style="color: rgb(0, 0, 0);position: absolute;top: 20px;left: 20px;">辅导员：</span>
          <span v-if="lookdata.counselorAudit == 1" style="position: absolute;top: 20px;left: 120px;color: #298FE8;">未审核</span>
          <span v-if="lookdata.counselorAudit == 2" style="position: absolute;top: 20px;left: 120px;color: rgb(83 184 31);">审核通过</span>
          <span v-if="lookdata.counselorAudit == 3" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核拒绝</span>
          <span v-if="lookdata.counselorAudit == 4" style="position: absolute;top: 20px;left: 120px;">无需审核</span>
          <span v-if="lookdata.counselorAudit == 5" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核驳回</span>
        </div>

        <div v-if="lookdata.counselorAudit !== 5" style="width: 80%;height: 60px;border-bottom: 1px solid rgb(209, 209, 209);margin-left: 10%;margin-top: 20px;position: relative;">

          <span style="color: rgb(0, 0, 0);position: absolute;top: 20px;left: 20px;">系主任：</span>
          <span v-if="lookdata.chairManAudit == 1" style="position: absolute;top: 20px;left: 120px;color: #298FE8;">未审核</span>
          <span v-if="lookdata.chairManAudit == 2" style="position: absolute;top: 20px;left: 120px;color: rgb(83 184 31);">审核通过</span>
          <span v-if="lookdata.chairManAudit == 3" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核拒绝</span>
          <span v-if="lookdata.chairManAudit == 4" style="position: absolute;top: 20px;left: 120px;">无需审核</span>
          <span v-if="lookdata.chairManAudit == 5" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核驳回</span>
        </div>

        <div v-if="lookdata.counselorAudit !== 5 || lookdata.chairManAudit !== 5" style="width: 80%;height: 60px;border-bottom: 1px solid rgb(209, 209, 209);margin-left: 10%;margin-top: 20px;position: relative;">
          <span style="color: rgb(0, 0, 0);position: absolute;top: 20px;left: 20px;">活动管理员</span>
          <span v-if="lookdata.psyCenterAudit == 1" style="position: absolute;top: 20px;left: 120px;color: #298FE8;">未审核</span>
          <span v-if="lookdata.psyCenterAudit == 2" style="position: absolute;top: 20px;left: 120px;color: rgb(83 184 31);">审核通过</span>
          <span v-if="lookdata.psyCenterAudit == 3" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核拒绝</span>
          <span v-if="lookdata.psyCenterAudit == 4" style="position: absolute;top: 20px;left: 120px;">无需审核</span>
          <span v-if="lookdata.psyCenterAudit == 5" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核驳回</span>
        </div>

        <div v-if="lookdata.counselorAudit !== 5 || lookdata.chairManAudit !== 5 || lookdata.psyCenterAudit !== 5" style="width: 80%;height: 60px;border-bottom: 1px solid rgb(209, 209, 209);margin-left: 10%;margin-top: 20px;position: relative;">
          <span style="color: rgb(0, 0, 0);position: absolute;top: 20px;left: 20px;">心理中心主任：</span>
          <span v-if="lookdata.centerDirectorAudit == 1" style="position:absolute;top: 20px;left: 120px;color: #298FE8;">未审核</span>
          <span v-if="lookdata.centerDirectorAudit == 2" style="position:absolute;top: 20px;left: 120px;color: rgb(83 184 31);">审核通过</span>
          <span v-if="lookdata.centerDirectorAudit == 3" style="position:absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核拒绝</span>
          <span v-if="lookdata.centerDirectorAudit == 4" style="position:absolute;top: 20px;left: 120px;">无需审核</span>
          <span v-if="lookdata.centerDirectorAudit == 5" style="position:absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核驳回</span>
        </div>

        <div v-if="lookdata.counselorAudit !== 5 || lookdata.chairManAudit !== 5 || lookdata.psyCenterAudit !== 5 || lookdata.centerDirectorAudit !== 5" style="width: 80%;height: 60px;border-bottom: 1px solid rgb(209, 209, 209);margin-left: 10%;margin-top: 20px;position: relative;">
          <span style="color: rgb(0, 0, 0);position: absolute;top: 20px;left: 20px;">校长：</span>
          <span v-if="lookdata.principalAudit == 1" style="position: absolute;top: 20px;left: 120px;color: #298FE8;">未审核</span>
          <span v-if="lookdata.principalAudit == 2" style="position: absolute;top: 20px;left: 120px;color: rgb(83 184 31);">审核通过</span>
          <span v-if="lookdata.principalAudit == 3" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核拒绝</span>
          <span v-if="lookdata.principalAudit == 4" style="position: absolute;top: 20px;left: 120px;">无需审核</span>
          <span v-if="lookdata.principalAudit == 5" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核驳回</span>
          <div  v-if="lookdata.PrincipalName" style="height: 45px;width: 45px;background-color: rgba(0, 136, 255, 1);color: #fff;line-height: 45px;text-align: center;border-radius: 50%;position: absolute;right: 20px;top: 6px;">{{ lookdata.PrincipalName }}</div>
          <div v-else-if="!lookdata.PrincipalName && this.Global.pdroleid(1070)" style="height: 45px;width: 45px;background-color: rgba(0, 136, 255, 1);color: #fff;line-height: 45px;text-align: center;border-radius: 50%;position: absolute;right: 20px;top: 6px;" @click="dialogVisibles = true">+</div>
        </div>

        <div v-if="!this.Global.pdroleid(1057) && pdwq" style="margin-top: 20px;margin-left: 170px; position: relative;">
          <el-button type="primary" @click="passfun(3)">拒绝</el-button>
          <el-button type="primary" @click="passfun(5)">驳回</el-button>
          <el-button type="primary" @click="passfun(2)">同意</el-button>
          <el-button v-if="this.Global.pdroleid(1063) || this.Global.pdroleid(1089)" type="primary" @click="passfun(8)">提交系主任审核</el-button>
          <el-button v-if="this.Global.pdroleid(1082)" type="primary" @click="passfun(9)">提交中心主任审核</el-button>
        </div>
      </div>
      <div v-else>
        <div style="width: 80%;height: 60px;border-bottom: 1px solid rgb(209, 209, 209);margin-left: 10%;margin-top: 20px;position: relative;">
          <span style="color: rgb(0, 0, 0);position: absolute;top: 20px;left: 20px;">协会会长：</span>
          <span v-if="lookdata.associationPresidentAudit == 1" style="position: absolute;top: 20px;left: 120px;color: #298FE8;">未审核</span>
          <span v-if="lookdata.associationPresidentAudit == 2" style="position: absolute;top: 20px;left: 120px;color: rgb(83 184 31);">审核通过</span>
          <span v-if="lookdata.associationPresidentAudit == 3" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核拒绝</span>
          <span v-if="lookdata.associationPresidentAudit == 5" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核驳回</span>
          <span v-if="lookdata.associationPresidentAudit == 4" style="position: absolute;top: 20px;left: 120px;">无需审核</span>
        </div>
        <div style="width: 80%;height: 60px;border-bottom: 1px solid rgb(209, 209, 209);margin-left: 10%;margin-top: 20px;position: relative;">
          <span style="color: rgb(0, 0, 0);position: absolute;top: 20px;left: 20px;">活动管理员：</span>
          <span v-if="lookdata.psyCenterAudit == 1" style="position: absolute;top: 20px;left: 120px;color: #298FE8;">未审核</span>
          <span v-if="lookdata.psyCenterAudit == 2" style="position: absolute;top: 20px;left: 120px;color: rgb(83 184 31);">审核通过</span>
          <span v-if="lookdata.psyCenterAudit == 3" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核拒绝</span>
          <span v-if="lookdata.psyCenterAudit == 5" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核驳回</span>
          <span v-if="lookdata.psyCenterAudit == 4" style="position: absolute;top: 20px;left: 120px;">无需审核</span>
        </div>
        <div style="width: 80%;height: 60px;border-bottom: 1px solid rgb(209, 209, 209);margin-left: 10%;margin-top: 20px;position: relative;">
          <span style="color: rgb(0, 0, 0);position: absolute;top: 20px;left: 20px;">心理中心主任：</span>
          <span v-if="lookdata.centerDirectorAudit == 1" style="position:absolute;top: 20px;left: 120px;color: #298FE8;">未审核</span>
          <span v-if="lookdata.centerDirectorAudit == 2" style="position:absolute;top: 20px;left: 120px;color: rgb(83 184 31);">审核通过</span>
          <span v-if="lookdata.centerDirectorAudit == 3" style="position:absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核拒绝</span>
          <span v-if="lookdata.centerDirectorAudit == 5" style="position:absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核驳回</span>
          <span v-if="lookdata.centerDirectorAudit == 4" style="position:absolute;top: 20px;left: 120px;">无需审核</span>
        </div>
        <div style="width: 80%;height: 60px;border-bottom: 1px solid rgb(209, 209, 209);margin-left: 10%;margin-top: 20px;position: relative;">
          <span style="color: rgb(0, 0, 0);position: absolute;top: 20px;left: 20px;">校长：</span>
          <span v-if="lookdata.principalAudit == 1" style="position: absolute;top: 20px;left: 120px;color: #298FE8;">未审核</span>
          <span v-if="lookdata.principalAudit == 2" style="position: absolute;top: 20px;left: 120px;color: rgb(83 184 31);">审核通过</span>
          <span v-if="lookdata.principalAudit == 3" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核拒绝</span>
          <span v-if="lookdata.principalAudit == 5" style="position: absolute;top: 20px;left: 120px;color: rgb(228 80 46);">审核驳回</span>
          <span v-if="lookdata.principalAudit == 4" style="position: absolute;top: 20px;left: 120px;">无需审核</span>
          <div  v-if="lookdata.PrincipalName" style="height: 45px;width: 45px;background-color: rgba(0, 136, 255, 1);color: #fff;line-height: 45px;text-align: center;border-radius: 50%;position: absolute;right: 20px;top: 6px;">{{ lookdata.PrincipalName }}</div>
          <div v-else-if="!lookdata.PrincipalName && this.Global.pdroleid(1070)" style="height: 45px;width: 45px;background-color: rgba(0, 136, 255, 1);color: #fff;line-height: 45px;text-align: center;border-radius: 50%;position: absolute;right: 20px;top: 6px;" @click="dialogVisibles = true">+</div>
        </div>
        
        <div v-if="!this.Global.pdroleid(1057) &&  pdwq" style="margin-top: 20px;margin-left: 170px;">
          <el-button type="primary" @click="passfun(3)">拒绝</el-button>
          <el-button type="primary" @click="passfun(5)">驳回</el-button>
          <el-button type="primary" @click="passfun(2)">同意</el-button>
          <el-button v-if="this.Global.pdroleid(1063) || this.Global.pdroleid(1089)" type="primary" @click="passfun(8)">提交系主任审核</el-button>
          <el-button v-if="this.Global.pdroleid(1082)" type="primary" @click="passfun(9)">提交中心主任审核</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="选择审批负责人" :visible.sync="dialogVisibles" width="40%">
      <div class="wapprovers">
        <div class="wapprovers_left">
          <el-collapse v-model="activeNames">
            <!-- <el-collapse-item title="心理中心" name="1">
              <div class="sxbverd" style="cursor: pointer;" v-for="item in rendata.psychologist" :key="item.userID" @click="toren(item, '1062', '心理中心')">
                {{ item.name }}
              </div>
            </el-collapse-item>
            <el-collapse-item title="心理中心主任" name="3">
              <div class="sxbverd" style="cursor: pointer;" v-for="item in rendata.centerDirector" :key="item.userID" @click="toren(item, '1064', '心理中心主任')">
                {{ item.name }}
              </div>
            </el-collapse-item> -->
            <el-collapse-item title="校长" name="2">
              <div class="sxbverd" style="cursor: pointer;" v-for="item in rendata.principal" :key="item.userID" @click="toren(item, '1063', '校长')">{{ item.name }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="wapprovers_right">
          <p>当前选中</p>
          <ul class="approverdata">
            <li v-for="item in lookren" style="cursor: pointer;" :key="item.index" @click="delete_lookren(item)">{{item.name}}</li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibles = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibles = false,lookdata.principalAudit = 1">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pdwq:false,
      lookren: [],
      rendata:'',
      dialogVisibles:false,
      activeNames: ['1'],
      RoleID:JSON.parse(sessionStorage.getItem('xinxi')).RoleID,
      activeName: 'first',
      formInline: {
        pageSize:10,//每页显示数量
        pageIndex:1,//第几页
        holdType:'1',//举办方式 1-组织活动 2-自助活动 全部0
        eventType:'0',//活动类型 1-体验型活动 2-治疗性活动 全部0
        eventStatus:'',//审核状态 1-立项 2-审核中 3-审核通过 4-驳回修改 5-拒绝 6-发布 全部 0
        subject:'',//活动主题
        subjectTime:'',//活动日期
        times: '',//创建时间（查询自助活动用）
      },
      tableData: [],
      Counts: 0,
      loading: true,
      dialogVisible: false,
      lookdata: '',
      eventKey: '',
      formInline2: {
        pageSize:10,//每页显示数量
        pageIndex:1,//第几页
        holdType:'1',//举办方式 1-组织活动 2-自助活动 全部0
        eventType:'0',//活动类型 1-体验型活动 2-治疗性活动 全部0
        eventStatus:'',//审核状态 1-立项 2-审核中 3-审核通过 4-驳回修改 5-拒绝 6-发布 全部0
        subject:'',//活动主题
        subjectTime:'',//活动日期
        times:'',//创建时间（查询自助活动用）
      },
      tableData2: [],
      Counts2: 0,
      loading2: true,
      Counselor: '',
      PsyCenter: '',
      ChairMan: '',
    };
  },
  methods: {
    delete_lookren(val) {
      this.lookren.splice(this.lookren.indexOf(val),1);
      if (val.type == '1') {
        this.Counselor = "";
      } else if (val.type == '2') {
        this.PsyCenter = "";
      } else if (val.type == '3') {
        this.ChairMan = "";
      }
    },
    toren(val, v, s) {
      if (s == '心理中心') {
        if (this.Counselor) {
          alert("只能添加一个心理中心审批角色")
        } else {
          this.Counselor = val.userID;
          val.type = 1;
          this.lookren.push(val);
          this.lookren = Array.from(new Set(this.lookren));
        }
      } else if (s == '校长') {
        if (this.PsyCenter) {
          alert("只能添加一个校长审批角色");
        } else {
          this.PsyCenter = val.userID;
          val.type = 2;
          this.lookren.push(val);
          this.lookren = Array.from(new Set(this.lookren));
        }
      } else if (s == '心理中心主任') {
        if (this.ChairMan) {
          alert("只能添加一个心理中心主任审批角色")
        } else {
          this.ChairMan = val.userID;
          val.type = 3;
          this.lookren.push(val);
          this.lookren = Array.from(new Set(this.lookren));
        }
      }
      this.chuanren = val.userID;
      this.vdoi = s;
    },
    passfun(auditStatus) {
      if(this.lookren.length>0){
        if(auditStatus == 8){
          var from = {
            eventKey: [this.eventKey],
            auditStatus: 2,
            Counselor:this.Counselor,
            PsyCenter:this.PsyCenter,
            ChairMan:this.ChairMan,
            principal: this.lookren[0].userID,
            isCommitChairMan:1,
          }
        }else if(auditStatus == 9) {
          var from = {
            eventKey: [this.eventKey],
            auditStatus: 2,
            Counselor:this.Counselor,
            PsyCenter:this.PsyCenter,
            ChairMan:this.ChairMan,
            principal: this.lookren[0].userID,
            isCommitCenterDirector:1,
          }
        }else{
          var from = {
            eventKey: [this.eventKey],
            auditStatus: auditStatus,
            Counselor:this.Counselor,
            PsyCenter:this.PsyCenter,
            ChairMan:this.ChairMan,
            principal: this.lookren[0].userID
          }
        }
        
      }else{

        if(auditStatus == 8){
          var from = {
            eventKey: [this.eventKey],
            auditStatus: 2,
            Counselor:this.Counselor,
            PsyCenter:this.PsyCenter,
            ChairMan:this.ChairMan,
            principal: '',
            isCommitChairMan:1,
          }
        }else if(auditStatus == 9){
          var from = {
            eventKey: [this.eventKey],
            auditStatus: 2,
            Counselor:this.Counselor,
            PsyCenter:this.PsyCenter,
            ChairMan:this.ChairMan,
            principal: '',
            isCommitCenterDirector:1
          }
        }else{
          var from = {
            eventKey: [this.eventKey],
            auditStatus: auditStatus,
            Counselor:this.Counselor,
            PsyCenter:this.PsyCenter,
            ChairMan:this.ChairMan,
            principal: ''
          }
        }
      }
      this.$Http_Post("/activitymanagement/auditeventplan", { from: from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dialogVisible = false;
          this.getcurrenteventplanlist();
          this.Global.request_successful(res.Message);
        } else {
          this.loadings = false;
          this.Global.request_failure(res.Message);
        }
      })
    },
    looks(row,type) {
      if(type == 2){
        this.pdwq = false;
      }else if(type == 1){
        this.pdwq = true;
      } 
      this.eventKey = row.eventKey;
      var from = { eventKey: row.eventKey };
      this.$Http_Post("/activitymanagement/fxeventplan", {from: from}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.lookdata = res.Data;
          this.dialogVisible = true;
        } else {
          this.loadings = false;
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleClick(tab, event) {
      if (this.activeName == 'first') {
        this.getcurrenteventplanlist();
      } else {
        this.getpasteventplanlist();
      }
    },
    onReset() {
      this.formInline=this.$options.data().formInline;
      this.getcurrenteventplanlist();
    },
    onSubmit() {
      this.formInline.pageIndex = 1
      this.getcurrenteventplanlist();
    },
    onSubmit2() {
      this.formInline2.pageIndex = 1
      this.getpasteventplanlist();
    },
    getpasteventplanlist() {//往期
      this.$Http_Post("/activitymanagement/getpasteventplanlist", {
        pageSize: this.formInline2.pageSize,//每页显示数量
        pageIndex: this.formInline2.pageIndex,//第几页
        subject: this.formInline2.subject,//活动主题
        eventType: this.formInline2.eventType,//活动类型
        holdType: this.formInline2.holdType,//举办方式
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loading2 = false;
          this.tableData2 = res.Data;
          this.Counts2 = Number(res.Counts);
        } else {
          this.loadings = false;
          this.Global.request_failure(res.Message);
        }
      })
    },
    getcurrenteventplanlist() {//待处理
      this.$Http_Post("/activitymanagement/getcurrenteventplanlist",{
        pageSize: this.formInline.pageSize,//每页显示数量
        pageIndex: this.formInline.pageIndex,//第几页
        subject: this.formInline.subject,//活动主题
        eventType: this.formInline.eventType,//活动类型
        holdType: this.formInline.holdType,//举办方式
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loading = false;
          this.tableData = res.Data;
          this.Counts = Number(res.Counts);
        } else {
          this.loadings = false;
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleCurrentChange(val) {
      this.formInline.pageIndex = val;
      this.getcurrenteventplanlist();
    },
    handleCurrentChange2(val) {
      this.formInline2.pageIndex = val;
      this.getpasteventplanlist();
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
      .then(_ => {
        done();
      })
      .catch(_ => {});
    }
  },
  mounted() {
    this.handleCurrentChange();
    this.$Http_Post("activitymanagement/getuserlist").then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.rendata = res.Data;
      }
    });
  },
};
</script>
<style>
  .ExamineActivity{width: 100%;height: 100%;background-color: #fff;}
  .ExamineActivity .list-cnt{width: 100%;height: 100%;background-color: #fff;}
  .ExamineActivity .el-tabs__header{width: 98%;margin-left: 1%;}
  .wapprovers {width: 90%;margin-left: 5%;height: 500px;border: #bdc0c2 1px solid;}
  .wapprovers .wapprovers_left input {width: 100% !important;height: 34px;margin-left: 10%;margin-top: 10px;background-color: #e2e2e2;border: none;}
  .wapprovers .wapprovers_left {width: calc(50% - 2px);border-right: 1px solid #bdc0c2;height: 100%;float: left;}
  .wapprovers .wapprovers_left .sxbverd {height: 40px;text-align: center;line-height: 40px;background-color: #409EFF;color: #fff;width: 40px;border-radius: 50%;float: left;margin-left: 6px;margin-bottom: 10px;}
  .wapprovers .wapprovers_left button {width: 80px;height: 30px;float: right;text-align: center;line-height: 30px;margin-right: 10px;margin-top: 10px;}
  .wapprovers .wapprovers_right {width: 50%;float: left;}
  .wapprovers .wapprovers_right p {font-size: 18px;margin-left: 10px;margin-top: 10px;font-weight: 500;}
  .approverdata li {float: left;height: 40px;text-align: center;line-height: 40px;background-color: #409EFF;color: #fff;width: 40px;border-radius: 50%;margin-left: 10px;margin-top: 10px;margin-bottom: 10px;}
</style>
